import * as d3 from "d3";
import $ from 'jquery';
import { addCommas, genderTooltip, downloadData } from './helpers';
import * as axios from 'axios';

const parseDate = d3.timeParse("%Y-%m-%d");

function racecomp() {

  const caseData = axios.get("https://docs.google.com/spreadsheets/d/e/2PACX-1vRb8zyDNZXyPrSgwxUxENm2jKPV-ewDJF_CbEGWvCNuYzXZT_6YwCv209lTeyI6tUIL6jRl6ZWD5Dcv/pub?gid=1704181121&single=true&output=csv")
    .then(content => {
      const justData = content.data
      const facilities = d3.csvParse(justData)

      var parseDate = d3.timeParse("%Y-%m-%d");
      facilities.forEach(function (d) {
        d.newDate = parseDate(d.date);
      })
      facilities.sort((a, b) => a.newDate - b.newDate)

      const datalength = facilities.length

      const currentDate = facilities[datalength - 1].newDate
      var formatDate = d3.timeFormat("%Y-%m-%d");

      const allCurrentDate = facilities.filter(d => d.date == formatDate(currentDate))

      const totalPop = d3.nest()
        .rollup(v => d3.sum(v, d => d.value))
        .entries(allCurrentDate);

      const raceData = axios.get("https://docs.google.com/spreadsheets/d/e/2PACX-1vRb8zyDNZXyPrSgwxUxENm2jKPV-ewDJF_CbEGWvCNuYzXZT_6YwCv209lTeyI6tUIL6jRl6ZWD5Dcv/pub?gid=618758641&single=true&output=csv")
        .then(content => {
          const raceData = content.data
          const race = d3.csvParse(raceData)

          race.forEach(function (d) {
            d.value = +d.value;
            d.newDate = parseDate(d.date);
          });
          race.sort((a, b) => a.newDate - b.newDate)

          const datalength = race.length

          const currentDate = race[datalength - 1].newDate

          var formatDate = d3.timeFormat("%Y-%m-%d");
          const blackPopCurrentDate = race.filter(d => d.date == formatDate(currentDate) && d.race == "Black")
          const latinXPopCurrentDate = race.filter(d => d.date == formatDate(currentDate) && d.race == "Hispanic")

          const blackPopTotal = d3.nest()
            .rollup(v => d3.sum(v, d => d.value))
            .entries(blackPopCurrentDate);

          const latinXPopTotal = d3.nest()
            .rollup(v => d3.sum(v, d => d.value))
            .entries(latinXPopCurrentDate);

          const blackPercent = ((blackPopTotal / totalPop) * 100).toFixed(0)
          const latinxPercent = ((latinXPopTotal / totalPop) * 100).toFixed(0)

          var data = {
            labels: [
              'Afrodescendiente', 'Hispano/Latino'
            ],
            series: [
              {
                label: '% en la cárcel',
                values: [blackPercent, latinxPercent]
              },
              {
                label: '% en el condado de Los Ángeles',
                values: [8, 49]
              }]
          };

          var chartWidth = 525,
            barHeight = 30,
            groupHeight = barHeight * data.series.length,
            gapBetweenGroups = 15,
            spaceForLabels = 180,
            spaceForLegend = 275;

          var zippedData = [];
          for (var i = 0; i < data.labels.length; i++) {
            for (var j = 0; j < data.series.length; j++) {
              zippedData.push(data.series[j].values[i]);
            }
          }

          var color = d3.scaleOrdinal().range(["#EF4136", "#4D4E56"]);
          var chartHeight = barHeight * zippedData.length + gapBetweenGroups * data.labels.length;

          var x = d3.scaleLinear()
            .domain([0, d3.max(zippedData)])
            .range([0, chartWidth]);

          var y = d3.scaleLinear()
            .range([chartHeight + gapBetweenGroups, 0]);

          var yAxis = d3.axisLeft()
            .scale(y)
            .tickFormat('')
            .tickSize(0);

          var xAxis = d3.axisBottom(x).tickFormat(function (d) {
            return d;
          });

          var chart = d3.select(".racecompchart")
            .attr("width", spaceForLabels + chartWidth + spaceForLegend)
            .attr("height", chartHeight + 30);

          var bar = chart.selectAll("g")
            .data(zippedData)
            .enter().append("g")
            .attr("transform", function (d, i) {
              return "translate(" + spaceForLabels + "," + (i * barHeight + gapBetweenGroups * (0.5 + Math.floor(i / data.series.length))) + ")";
            });

          bar.append("rect")
            .attr("fill", function (d, i) { return color(i % data.series.length); })
            .attr("class", "bar")
            .attr("width", x)
            .attr("height", barHeight - 1);

          bar.append("text")
            .attr("x", function (d) { return x(d) + 3; })
            .attr("y", barHeight / 2)
            .attr("fill", "#231F20")
            .attr("dy", ".35em")
            .text(function (d) { return d + '%' });

          bar.append("text")
            .attr("class", "label")
            .attr("x", function (d) { return -10; })
            .attr("y", groupHeight / 2)
            .attr("dy", ".35em")
            .attr('text-anchor', 'end')
            .text(function (d, i) {
              if (i % data.series.length === 0)
                return data.labels[Math.floor(i / data.series.length)];
              else
                return ""
            });

          chart.append("g")
            .attr("class", "y axis")
            .attr("transform", "translate(" + spaceForLabels + ", " + -gapBetweenGroups / 2 + ")")
            .call(yAxis);

          // chart.append("g")
          //   .attr("class", "x axis")
          //   .attr("transform", "translate(" + spaceForLabels + "," + (chartHeight - 9) + ")")
          //   .call(xAxis);

          var legendRectSize = 18,
            legendSpacing = 4;

          var legend = chart.selectAll('.legend')
            .data(data.series)
            .enter()
            .append('g')
            .attr('transform', function (d, i) {
              var height = legendRectSize + legendSpacing;
              var offset = -gapBetweenGroups / 2;
              var horz = spaceForLabels + chartWidth + 40 - legendRectSize;
              var vert = i * height - offset;
              return 'translate(' + horz + ',' + vert + ')';
            });

          legend.append('rect')
            .attr('width', legendRectSize)
            .attr('height', legendRectSize)
            .style('fill', function (d, i) { return color(i); })
            .style('stroke', function (d, i) { return color(i); });

          legend.append('text')
            .attr('class', 'legend')
            .attr('x', legendRectSize + legendSpacing)
            .attr('y', legendRectSize - legendSpacing)
            .text(function (d) { return d.label; });

        })
    })
}

export { racecomp }